import { render, staticRenderFns } from "./Tier-Editor.vue?vue&type=template&id=2f0f5668&scoped=true&"
import script from "./Tier-Editor.vue?vue&type=script&lang=js&"
export * from "./Tier-Editor.vue?vue&type=script&lang=js&"
import style0 from "./Tier-Editor.vue?vue&type=style&index=0&id=2f0f5668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f5668",
  null
  
)

export default component.exports